/*
 *  Copyright (c) 2022-2023 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import styled from "styled-components";
import { theme } from "@nordcloud/gnui";

export const HomeAdminGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: ${theme.spacing.spacing04} ${theme.spacing.spacing03};

  /* Account for double gap, when what's new popup is closed */
  margin-top: -${theme.spacing.spacing04};

  .whatsnew > * {
    margin-top: ${theme.spacing.spacing04};
  }

  @media screen and (min-width: ${theme.breakpoints.xxl}px) {
    grid-template-columns: repeat(6, 1fr);
  }
`;

type ColumnSpan = 1 | 2 | 3 | 4 | 5 | 6;

type SpanProps = {
  [K in keyof typeof theme.breakpoints]?: ColumnSpan;
};

export const Span = styled.div<SpanProps>`
  ${(props) =>
    Object.entries(theme.breakpoints).map(([key, breakpoint]) =>
      getMediaQueryCss(props, key, breakpoint)
    )}
`;

const getMediaQueryCss = (props: SpanProps, key: string, breakpoint: number) =>
  hasKey(props, key)
    ? `@media screen and (min-width: ${breakpoint}px) {
      grid-column: span ${props[key]};
    }`
    : "";

const hasKey = (object: SpanProps, key: string): key is keyof SpanProps =>
  Object.hasOwn(object, key);
